import React from "react";
import { FieldRenderProps } from "react-final-form";
import { Select } from "../components/Inputs/Select";
import { Type, Validator } from "./Type";
import { Required } from "../index";

export interface EnumOptions
  extends Array<{
    label: string | (() => string);
    value: string | number | boolean | undefined | null;
  }> {}

export const EnumField = (options: EnumOptions, ...validators: Validator[]) => {
  const hasRequiredValidator = validators.indexOf(Required) !== -1;

  return new Type({
    // @ts-ignore
    Component: Select,
    PresentationComponent: (props: FieldRenderProps<any>) => {
      // todo: candidate for memoization
      const filtered = options.filter(
        option => option.value === props.input.value
      );

      const translatedLabel =
        typeof filtered[0].label === "function"
          ? filtered[0].label()
          : filtered[0].label;

      const v = filtered.length === 1 ? "" + translatedLabel : "???";

      return <>{v}</>;
    },
    props: {
      options,
      clearable: !hasRequiredValidator,
      parse: (v: any) => {
        if (v === "") {
          return null;
        } else {
          return v;
        }
      }
    },
    validators
  });
};
